import { transport } from 'config/transport';

export function callApiGetListOfThuNoiTru(congDoanId, month, year) {
    return transport.get(`/noitru/${congDoanId}/thuchi/thunoitru`, { params: { month, year } });
}
